import { useQuery } from '@tanstack/react-query';
import { USER_ACCESS_QUERY_KEY } from '~/queries/keys';

import userManagementApi from '.';
import { MeResponse } from './userAccess.types';

export const useCurrentUserAccess = ({ entityId }: { entityId: String }) =>
  useQuery<MeResponse>({
    queryKey: [USER_ACCESS_QUERY_KEY, { entityId }],
    queryFn: async () => {
      const response = await userManagementApi.get(
        `users-access/me?entity_id=${entityId}`,
      );
      return response.data;
    },
    enabled: entityId !== undefined,
  });

export const changeRoleUserAccess = ({
  entityId,
  newRole,
}: {
  entityId: String;
  newRole: String;
}): Promise<any> => {
  return userManagementApi.patch(`roles/users-access/${entityId}`, {
    role_names: [newRole],
  });
};
